export enum PTheme {
  LIGHT = 'light',
  DARK = 'dark',
}
